import XIcon from "components/icons/XIcon"
import { APP_INFO } from "constants/app_info"
import { motion } from "framer-motion"
import { useLang } from "hooks/useLang"
import dynamic from "next/dynamic"
import Image from "next/image"
import React from "react"
import { AiOutlineLike } from "react-icons/ai"
import { BsWhatsapp } from "react-icons/bs"
import {
    FiFacebook,
    FiInstagram,
    FiLinkedin,
    FiMail,
    FiPhone,
} from "react-icons/fi"
import ServiceCard from "./ServiceCard"
import AboutUsHero from "./CreateYourEventHero"
import EventMakingSectionCompany from "./EventMakingSectionDir/EventMakingSectionCompany"
import EventMakingSectionIndividual from "./EventMakingSectionDir/EventMakingSectionIndividual"
import { PassTicketsFeatures } from "./features"
import { COMPANY_INFO } from "constants/company_info"
import Form from "components/FormsPage/ContactUs/Form"
import ContactDetails from "components/FormsPage/ContactUs/ContactDetails"
import AppBanner from "components/Sections/AppsSection/AppBanner"

const Footer = dynamic(() => import("components/Layout/Footer/Footer"), {
    ssr: false,
    loading: () => {
        return (
            <footer
                className={`fixed bottom-0 hidden h-[325px] flex-col overflow-hidden bg-white shadow-[0_0_9px_5px_rgba(0,0,0,0.05)] dark:bg-[#3A2B87] md:flex`}></footer>
        )
    },
})
const CreateYourEventComponent = () => {
    const { t, isAr } = useLang()
    const position = isAr ? "left" : "right"
    return (
        // I removed "parallax-container" className from the div below temporarily so the Navbar can animate properly
        <div className="bg-gradient-to-b from-[#221852] to-[#18113B]">
            <div className="parallax-slide w-full">
                <AboutUsHero />
            </div>

            <div className="parallax-slide relative mx-auto items-center justify-center">
                <div className="relative flex h-screen w-full items-center justify-center overflow-hidden">
                    <Image
                        src="/images/family-in-roller-coaster.webp"
                        alt="About Us Page Banner"
                        layout="fill"
                        objectFit="cover"
                        quality="100"
                    />
                    <div
                        className="absolute bottom-20 right-20 flex"
                        style={{
                            backdropFilter: "blur(5px)",
                            background: "rgba(0, 0, 0, 0.5)",
                        }}>
                        <span
                            className="bg-black/50 p-5 text-[24px] text-white md:text-[36px] lg:text-[48px]"
                            dir="rtl">
                            المنصة الاولى <br />
                            من نوعها في مجال <br />
                            إدارة وتنظيم الفعاليات.
                        </span>
                    </div>
                </div>
            </div>

            <div className="parallax-slide layout">
                <div className="flex flex-col pt-20 lg:gap-4">
                    <span className="text-4xl font-normal text-white">
                        نخدمك بعيوننا
                    </span>
                    <div className="flex flex-col items-center justify-center gap-2 py-4 lg:mx-auto lg:grid lg:grid-cols-3 lg:gap-4">
                        {PassTicketsFeatures.map((feature) => (
                            <ServiceCard
                                key={feature.service}
                                service={feature.service}
                                media={feature.media}
                                description={feature.description}
                            />
                        ))}
                    </div>
                    <div className="text-end text-4xl font-normal text-white">
                        ولسا ماخلصنا ..
                    </div>
                </div>
            </div>

            <motion.div
                className="parallax-slide flex h-screen flex-col items-center justify-center gap-12"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}>
                <div className="text-center text-4xl font-bold text-white lg:text-8xl">
                    ليش باس تيكت؟
                </div>
                <div className="text-center text-3xl font-light text-white lg:text-7xl">
                    تنــوع .. خدمـات .. حلـول
                </div>
                <div className="text-center text-2xl font-light leading-10 text-white lg:text-4xl">
                    نسعى لتوفير أفضل فرص الفعاليات
                    <br />
                    والأنشطة لسكان المملكة وزوارها.
                </div>
            </motion.div>

            {/* <AppsMessage /> */}
            {/* 
            <motion.div className="parallax-slide h-screen">
                <EventsTypes />
            </motion.div> */}

            {/*<motion.div className="parallax-slide flex h-screen items-center justify-center lg:block">*/}
            {/*    <div className="py-12">*/}
            {/*        <Image*/}
            {/*            src="/images/events-making-bg-transparent.png"*/}
            {/*            alt="bit rate"*/}
            {/*            width={0}*/}
            {/*            height={0}*/}
            {/*            layout="responsive"*/}
            {/*            className="h-full w-full bg-cover bg-center"*/}
            {/*        />*/}
            {/*    </div>*/}
            {/*</motion.div>*/}

            <div className="parallax-slide hidden lg:block">
                <EventMakingSectionCompany />
            </div>
            <div className="parallax-slide hidden lg:block">
                <EventMakingSectionIndividual />
            </div>
            {/*<div className="parallax-slide flex h-screen flex-col items-center justify-center">*/}
            {/*    <div className="mx-4 flex flex-col items-center justify-center gap-12 rounded-3xl bg-teal-500 px-2 py-16 lg:mx-auto lg:w-3/4">*/}
            {/*        <p className="text-center text-3xl font-bold text-white lg:text-6xl">*/}
            {/*            باختصار خلينا*/}
            {/*        </p>*/}
            {/*        <p className="text-center text-3xl font-bold text-white lg:text-6xl">*/}
            {/*            نخلق تجربة رائعة مع بعض*/}
            {/*        </p>*/}
            {/*        <button className="h-14 w-60 rounded-2xl bg-orange-300 capitalize">*/}
            {/*            {t("contact_us")}*/}
            {/*        </button>*/}
            {/*    </div>*/}
            {/*</div>*/}

            {/*<div className="flex h-screen flex-col items-center justify-center gap-8">*/}
            {/*    <div className="h-20 w-36 lg:h-40 lg:w-72">*/}
            {/*        <Image*/}
            {/*            src="/images/logo.png"*/}
            {/*            alt="alt"*/}
            {/*            width={0}*/}
            {/*            height={0}*/}
            {/*            style={{*/}
            {/*                objectFit: "fill",*/}
            {/*            }}*/}
            {/*            layout="responsive"*/}
            {/*            className="h-full w-full bg-cover bg-center"*/}
            {/*        />*/}
            {/*    </div>*/}
            {/*<div className="parallax-slide mx-4 text-center text-2xl font-bold text-white lg:text-6xl">*/}
            {/*    تحــــــســــــبـــــــــــهــــــــــــــــــــــــا*/}
            {/*    <br />*/}
            {/*    خيـــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــال*/}
            {/*</div>*/}
            {/*</div>*/}
            <div className="parallax-slide flex h-screen items-center justify-center">
                <div className="flex-1 layout">
                    <h1 className="mb-5 text-[56px] font-bold leading-[50px] md:mb-8 md:text-[100px] md:leading-[100px]">
                        {t("create_your_event")}
                    </h1>

                    <div className="flex flex-col items-start md:flex-row">
                        <Form />
                        <ContactDetails />
                    </div>
                </div>
            </div>
            <div className="parallax-slide h-screen lg:hidden">
                <div className="relative flex h-full flex-1 items-center justify-center pt-10 md:pt-0">
                    <Image
                        src={"/svg/v2/half-sparkle.png"}
                        alt="sparkle"
                        className={`absolute bottom-0 ${position}-0 hidden md:flex`}
                        style={{ objectFit: "contain" }}
                        height={200}
                        width={200}
                    />
                    <div className="flex flex-col gap-8">
                        <div className="flex gap-2">
                            <FiMail
                                size={25}
                                color="#FD0058"
                            />
                            <div className="flex flex-col gap-2">
                                <span className="text-sm font-bold md:text-base">
                                    {t("email_address")}
                                </span>
                                <p className="text-sm md:text-base">
                                    {APP_INFO.email}
                                </p>
                            </div>
                        </div>
                        <div className="flex gap-2">
                            <FiPhone
                                size={25}
                                color="#FD0058"
                            />
                            <div className="flex flex-col gap-2">
                                <span className="text-sm font-bold md:text-base">
                                    {t("phone")}
                                </span>
                                <p
                                    style={{ direction: "ltr" }}
                                    className="text-sm md:text-base">
                                    {APP_INFO.phone}
                                </p>
                            </div>
                        </div>
                        <div className="flex gap-2">
                            <BsWhatsapp
                                size={25}
                                color="#FD0058"
                            />
                            <div className="flex flex-col gap-2">
                                <span className="text-sm font-bold md:text-base">
                                    {t("whatsapp")}
                                </span>
                                <p
                                    style={{ direction: "ltr" }}
                                    className="text-sm md:text-base">
                                    {APP_INFO.social_media.whatsapp}
                                </p>
                            </div>
                        </div>
                        <div className="flex gap-2">
                            <AiOutlineLike
                                size={25}
                                color="#FD0058"
                            />
                            <div className="flex flex-col gap-2">
                                <span className="text-sm font-bold md:text-base">
                                    {t("follow_us")}
                                </span>
                                <div className="flex items-center gap-3 md:gap-4">
                                    <FiFacebook
                                        size={22}
                                        className="cursor-pointer opacity-70 hover:opacity-100"
                                    />
                                    <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href={
                                            COMPANY_INFO.social_media.instagram
                                        }>
                                        <FiInstagram
                                            size={22}
                                            className="cursor-pointer opacity-70 hover:opacity-100"
                                        />
                                    </a>
                                    <XIcon className="cursor-pointer opacity-70 hover:opacity-100" />
                                    <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href={
                                            COMPANY_INFO.social_media.linkedin
                                        }>
                                        <FiLinkedin
                                            size={22}
                                            className="cursor-pointer opacity-70 hover:opacity-100"
                                        />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="parallax-slide h-screen">
                <div className="flex h-full flex-col items-center justify-center">
                    <AppBanner />
                </div>
            </div>
            <div className="parallax-slide">
                <Footer />
            </div>
        </div>
    )
}
export default CreateYourEventComponent
